import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment-jalaali";
import "./index.css";

function AddSessionModal({
  closeModal,
  clinicUsers,
  selectedUser,
  currentUser,
}) {
  const [isReceiving, setIsReceiving] = useState(false);
  const [sessionTitle, setSessionTitle] = useState("");
  const [sessionPlan, setSessionPlan] = useState("");
  const [sessionReport, setSessionReport] = useState("");
  const [sessionDay, setSessionDay] = useState(0);
  const [sessionMonth, setSessionMonth] = useState(0);
  const [sessionYear, setSessionYear] = useState(0);
  const [sessionAudienceId, setSessionAudienceId] = useState(0);
  const [sessionPlannerId, setSessionPlannerId] = useState(0);
  const [sessionTherapistId, setSessionTherapistId] = useState(-1);
  const [addSessionError, setAddSessionError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [sessionId, setSessionId] = useState(0);

  useEffect(() => {
    console.log("TestAddSession");
  });

  const handleSessionName = (sessionId) => {
    setSessionId(sessionId);
    if (sessionId == 1) setSessionName("کاردرمانی");
    if (sessionId == 2) setSessionName("گفتاردرمانی");
    if (sessionId == 3) setSessionName("رفتاردرمانی");
    if (sessionId == 4) setSessionName("موسیقی‌درمانی");
    if (sessionId == 5) setSessionName("شناختی‌ذهنی");
    if (sessionId == 6) setSessionName("روانشناسی");
  };

  const submitAddSession = async () => {
    var sessionDate = "";
    if (
      sessionDay == 0 ||
      sessionMonth == 0 ||
      sessionYear == 0 ||
      sessionId == 0 ||
      sessionTherapistId === -1 ||
      sessionAudienceId === 0
    ) {
      setAddSessionError(true);
      setMessageError("لطفا تمامی مقادیر الزامی را وارد کنید");
      return;
    } else {
      sessionDate = moment(
        sessionYear.toString() +
          "/" +
          sessionMonth.toString() +
          "/" +
          sessionDay.toString() +
          " 00:00:00",
        "jYYYY/jM/jD HH:mm:ss"
      ).format("YYYY-M-D HH:mm:ss");
      setAddSessionError(false);
    }

    setIsReceiving(true);
    const result = await axios.post(
      "https://request.kidiar.com/sessions/create",
      {
        sessiondate: sessionDate,
        sessionname: sessionName,
        therapistid: sessionTherapistId,
        audienceid: sessionAudienceId,
        sessiontitle: sessionTitle,
        sessionplan: sessionPlan,
        sessionreport: sessionReport,
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    if (result.data.status == 1) {
      setIsReceiving(false);
      closeModal(false);
    } else {
      // setAddUserError(true)
      // setMessageError(result.data.message)
    }
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-title">افزودن جلسه</div>
        <div className="users-modal-title mode-text-7">
          در اینجا می‌توانید با وارد کردن مشخصات خواسته شده، جلسه مورد نظر خود
          را به کلینیک هوشمند اضافه کنید.
        </div>
        <div className="users-modal-body">
          <div className="d-flex mb-2 mode-text-9 font-15 ">مشخصات جلسه</div>
          <div className="d-flex mb-2">
            <div className="d-flex w-50">
              <select
                className="users-input"
                style={{ width: "100%" }}
                value={sessionId}
                onChange={(e) => {
                  handleSessionName(e.target.value);
                }}
              >
                <option value={0} disabled hidden>
                  نوع جلسه
                </option>
                <option value={1}>کاردرمانی</option>
                <option value={2}>گفتاردرمانی</option>
                <option value={3}>رفتاردرمانی</option>
                <option value={4}>موسیقی‌درمانی</option>
                <option value={5}>شناختی‌ذهنی</option>
                <option value={6}>روانشناسی</option>
              </select>
            </div>
            <div className="d-flex w-50">
              <select
                className="users-input"
                style={{ width: "33.33%" }}
                value={sessionDay}
                onChange={(e) => setSessionDay(e.target.value)}
              >
                <option value={0}>روز</option>
                <option value={1}>۱</option>
                <option value={2}>۲</option>
                <option value={3}>۳</option>
                <option value={4}>۴</option>
                <option value={5}>۵</option>
                <option value={6}>۶</option>
                <option value={7}>۷</option>
                <option value={8}>۸</option>
                <option value={9}>۹</option>
                <option value={10}>۱۰</option>
                <option value={11}>۱۱</option>
                <option value={12}>۱۲</option>
                <option value={13}>۱۳</option>
                <option value={14}>۱۴</option>
                <option value={15}>۱۵</option>
                <option value={16}>۱۶</option>
                <option value={17}>۱۷</option>
                <option value={18}>۱۸</option>
                <option value={19}>۱۹</option>
                <option value={20}>۲۰</option>
                <option value={21}>۲۱</option>
                <option value={22}>۲۲</option>
                <option value={23}>۲۳</option>
                <option value={24}>۲۴</option>
                <option value={25}>۲۵</option>
                <option value={26}>۲۶</option>
                <option value={27}>۲۷</option>
                <option value={28}>۲۸</option>
                <option value={29}>۲۹</option>
                {sessionMonth < 12 && <option value={30}>۳۰</option>}
                {sessionMonth < 7 && <option value={31}>۳۱</option>}
              </select>
              <select
                className="users-input"
                style={{ width: "33.33%" }}
                value={sessionMonth}
                onChange={(e) => {
                  if (e.target.value < 7) {
                  } else if (sessionDay == 31 && e.target.value < 12) {
                    setSessionDay(30);
                  } else if (sessionDay == 31 && e.target.value == 12) {
                    setSessionDay(29);
                  } else if (sessionDay == 30 && e.target.value == 12) {
                    setSessionDay(29);
                  }
                  setSessionMonth(e.target.value);
                }}
              >
                <option value={0}>ماه</option>
                <option value={1}>فروردین</option>
                <option value={2}>اردیبهشت</option>
                <option value={3}>خرداد</option>
                <option value={4}>تیر</option>
                <option value={5}>مرداد</option>
                <option value={6}>شهریور</option>
                <option value={7}>مهر</option>
                <option value={8}>آبان</option>
                <option value={9}>آذر</option>
                <option value={10}>دی</option>
                <option value={11}>بهمن</option>
                <option value={12}>اسفند</option>
              </select>
              <select
                className="users-input"
                style={{ width: "33.33%" }}
                value={sessionYear}
                onChange={(e) => setSessionYear(e.target.value)}
              >
                <option value={0}>سال</option>
                <option value={1402}>۱۴۰۲</option>
                <option value={1401}>۱۴۰۱</option>
                <option value={1400}>۱۴۰۰</option>
                <option value={1399}>۱۳۹۹</option>
                <option value={1398}>۱۳۹۸</option>
                <option value={1397}>۱۳۹۷</option>
                <option value={1396}>۱۳۹۶</option>
                <option value={1395}>۱۳۹۵</option>
                <option value={1394}>۱۳۹۴</option>
                <option value={1393}>۱۳۹۳</option>
                <option value={1392}>۱۳۹۲</option>
                <option value={1391}>۱۳۹۱</option>
                <option value={1390}>۱۳۹۰</option>
                <option value={1389}>۱۳۸۹</option>
                <option value={1388}>۱۳۸۸</option>
                <option value={1387}>۱۳۸۷</option>
                <option value={1386}>۱۳۸۶</option>
                <option value={1385}>۱۳۸۵</option>
                <option value={1384}>۱۳۸۴</option>
                <option value={1383}>۱۳۸۳</option>
                <option value={1382}>۱۳۸۲</option>
                <option value={1381}>۱۳۸۱</option>
                <option value={1380}>۱۳۸۰</option>
                <option value={1379}>۱۳۷۹</option>
                <option value={1378}>۱۳۷۸</option>
                <option value={1377}>۱۳۷۷</option>
                <option value={1376}>۱۳۷۶</option>
                <option value={1375}>۱۳۷۵</option>
                <option value={1374}>۱۳۷۴</option>
                <option value={1373}>۱۳۷۳</option>
                <option value={1372}>۱۳۷۲</option>
                <option value={1371}>۱۳۷۱</option>
                <option value={1370}>۱۳۷۰</option>
                <option value={1369}>۱۳۶۹</option>
                <option value={1368}>۱۳۶۸</option>
                <option value={1367}>۱۳۶۷</option>
                <option value={1366}>۱۳۶۶</option>
                <option value={1365}>۱۳۶۵</option>
                <option value={1364}>۱۳۶۴</option>
                <option value={1363}>۱۳۶۳</option>
                <option value={1362}>۱۳۶۲</option>
                <option value={1361}>۱۳۶۱</option>
                <option value={1360}>۱۳۶۰</option>
                <option value={1359}>۱۳۵۹</option>
                <option value={1358}>۱۳۵۸</option>
                <option value={1357}>۱۳۵۷</option>
                <option value={1356}>۱۳۵۶</option>
                <option value={1355}>۱۳۵۵</option>
                <option value={1354}>۱۳۵۴</option>
              </select>
            </div>
          </div>
          <div className="d-flex mb-2">
            <div className="d-flex w-50">
              <p className="users-modal-title mode-text-7 w-100">
                {"درمانگر:"}
              </p>
            </div>
            <div className="d-flex w-50">
              <select
                className="users-input"
                style={{ width: "100%" }}
                value={sessionTherapistId}
                onChange={(e) => setSessionTherapistId(e.target.value)}
              >
                <option value={-1} disabled hidden>
                  انتخاب کنید ...
                </option>
                {(currentUser.access === "Clinic" ||
                  currentUser.access === "Therapist") && (
                  <option value={currentUser.id}>
                    {currentUser.firstname} {currentUser.lastname}
                  </option>
                )}
                {clinicUsers.map(
                  (clinicUser, i) =>
                    clinicUser.access == "Therapist" && (
                      <option value={clinicUser.id}>
                        {clinicUser.firstname} {clinicUser.lastname}
                      </option>
                    )
                )}
              </select>
            </div>
            <div className="d-flex w-50">
              <p className="users-modal-title mode-text-7 w-100">{"مراجع:"}</p>
            </div>
            <div className="d-flex w-50">
              <select
                className="users-input"
                style={{ width: "100%" }}
                value={sessionAudienceId}
                onChange={(e) => setSessionAudienceId(e.target.value)}
              >
                <option value={0} disabled hidden>
                  انتخاب کنید ...
                </option>
                {clinicUsers.map(
                  (clinicUser, i) =>
                    clinicUser.access == "User" && (
                      <option value={clinicUser.id}>
                        {clinicUser.firstname} {clinicUser.lastname}
                      </option>
                    )
                )}
              </select>
            </div>
          </div>
          <div className="d-flex mb-2 mode-text-9 font-15 ">عنوان جلسه</div>
          <div className="d-flex mb-2">
            <div className="d-flex w-100">
              <input
                type="text"
                placeholder="در چند کلمه اهداف جلسه را بنویسید"
                className="users-input w-100"
                value={sessionTitle}
                onChange={(e) => setSessionTitle(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="d-flex mb-2 mode-text-9 font-15 ">برنامه جلسه</div>
          <div className="d-flex mb-2">
            <div className="d-flex w-100">
              <textarea
                type="text"
                placeholder="توضیحات بیشتر ..."
                className="users-input w-100"
                style={{ minHeight: "80px" }}
                value={sessionPlan}
                onChange={(e) => setSessionPlan(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="d-flex mb-2 mode-text-9 font-15 ">گزارش جلسه</div>
          <div className="d-flex mb-2">
            <div className="d-flex w-100">
              <textarea
                type="text"
                placeholder="توضیحات بیشتر ..."
                className="users-input w-100"
                style={{ minHeight: "160px" }}
                value={sessionReport}
                onChange={(e) => setSessionReport(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="modal-footer mode-bg-8 d-ltr">
          <button onClick={() => closeModal(false)}>انصراف</button>
          {isReceiving ? (
            <button className="btn solid d-flex justify-content-center align-items-center">
              <div className="spinner"></div>
            </button>
          ) : (
            <button
              className="d-flex justify-content-center align-items-center"
              onClick={submitAddSession}
            >
              <p>تایید</p>
            </button>
          )}
        </div>
        <div className="error-text">
          {addSessionError && <p>{messageError}</p>}
        </div>
      </div>
    </div>
  );
}

export default AddSessionModal;
